<template>
  <header class="ips-login__header">
    <div class="pdt-44 pdl-50">
      <img class="logo" src="../../../assets/images/justbon/logo/yiai-logo--h.png" alt/>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
  , data() {
    return {}
  }
  , computed: {}
  , methods: {}
}
</script>

<style lang="scss" scoped>
</style>
